import useStore, { GetSliceStoreProps, SetSliceStoreProps } from "../useStore"; // Certifique-se de que o caminho está correto

enum CommonStoreEvents {
  SET_LOADING = "SET_LOADING",
}


export type CommonSliceState = {
  loaders: {
    [key: string]: boolean;
  };
  setLoader: (key: string, loading: boolean) => void;
}

const CommonSlice = (set: SetSliceStoreProps, get: GetSliceStoreProps): CommonSliceState => {
  const setLoader = (key: string, loading: boolean) => {

    set((state) => ({
      commonSlice: {
        ...state.commonSlice, // Mantém a referência correta
        loaders: {
          ...state.commonSlice.loaders,
          [key]: loading,
        },
      },
    }), false, CommonStoreEvents.SET_LOADING);
  };


  return {
    loaders: {},
    setLoader,
  };
};

export default CommonSlice;

// Função auxiliar para alterar o estado de qualquer lugar fora de um componente React
export const setLoader = (key: string, value: boolean) => {
  const state = useStore.getState(); // Obtém a store global
  if (state?.commonSlice?.setLoader) {
    state.commonSlice.setLoader(key, value);
  } else {
    console.error("Erro: commonSlice.setLoader não está definido.");
  }
};